import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  TGame,
  TQuizAttempt,
} from "../../../entities/Moodle/model/MoodleTypes";
import { moodleApi, moodleModel } from "../../../entities/Moodle";
import { adminModel } from "../../../entities/Admin";

export const useStartMoodleGame = ({ courseId }: { courseId: string }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isGamePassed, setIsGamePassed] = useState<boolean>(false);
  const game: TGame | null = useSelector(moodleModel.selectGame);
  const [error, setError] = useState<string>("");
  const user = useSelector(adminModel.selectUser);
  const dispatch = useDispatch();

  const getNextStage = () => {
    const func = isGamePassed ? moodleApi.restartGame : moodleApi.nextGameStage;
    console.log(func);
    if (game && user) {
      func(user.sub, courseId)
        .then((response) => {
          if (response.data?.exception) {
            setError(response.data.message);
          } else {
            dispatch(moodleModel.setGame(null));
            dispatch(moodleModel.setGame(response.data));
          }
        })
        .catch((e) => {
          setError(e);
        });
    }
  };

  const handleOk = () => {
    if (game) {
      getNextStage();
    }
  };

  const handleCansel = () => {
    setIsOpen(false);
    dispatch(moodleModel.setGame(null));
  };

  useEffect(() => {
    if (game == null) return setIsOpen(false);
    setIsGamePassed(game.game_is_done ? true : false);
    setIsOpen(true);
  }, [game]);

  return {
    game,
    isOpen,
    isGamePassed,
    error,
    handleOk,
    handleCansel,
  };
};
